import LessonFork from "../../../../src/components/lesson-fork";
import * as React from 'react';
export default {
  LessonFork,
  React
};